import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';
import WveInputNumber from 'SharedComponents/WveInputs/WveInputNumber/WveInputNumber';
import { toggleOffsetHeight } from 'Actions/UIActions';

const InputContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const WveInputOffsetHeight = ({
  inputProps,
  handleNumberUpdate,
  offsetHeightVisible,
  toggleOffsetHeight, // eslint-disable-line no-shadow
  }) =>

    <InputContainer>
      <WveInputNumber
        {...inputProps}
        handleUpdate={handleNumberUpdate}
      />
      <WveLinkButton
        handleClick={toggleOffsetHeight}
      >
        {`${offsetHeightVisible ? 'Hide' : 'Show'} header`}
      </WveLinkButton>
    </InputContainer>;

WveInputOffsetHeight.propTypes = {
  inputProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  handleNumberUpdate: PropTypes.func,
  offsetHeightVisible: PropTypes.bool,
  toggleOffsetHeight: PropTypes.func,
};

WveInputOffsetHeight.defaultProps = {
  offsetHeightVisible: false,
};

const mapStateToProps = state => ({
  offsetHeightVisible: state.getIn(['ui', 'offsetHeightVisible']),
});

const mapDispatchToProps = dispatch => ({
  toggleOffsetHeight: () => {
    dispatch(toggleOffsetHeight());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WveInputOffsetHeight);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputOffsetHeight/WveInputOffsetHeight.jsx